(function (w, d) {
  'use strict';
  if (w.__seoHelpConfirmationInstalled) { return; }
  w.__seoHelpConfirmationInstalled = true;
  var NEXT = '/pages/what-happens-next';
  var PENDING = 'seo_help_enquiry_pending_v1';
  var COMPLETED = 'seo_help_enquiry_completed_v1';
  var PENDING_AGE = 30 * 60 * 1000;
  var COMPLETED_AGE = 24 * 60 * 60 * 1000;
  var categories = ['local_seo', 'national_seo', 'b2b_seo', 'google_business_profile',
    'ai_search_discovery', 'seo_audits', 'ecommerce_seo', 'seo_migration', 'general'];
  var services = {
    '/pages/local-seo': 'local_seo', '/pages/national-seo': 'national_seo',
    '/pages/b2b-seo': 'b2b_seo', '/pages/google-business-profile': 'google_business_profile',
    '/pages/ai-search-discovery': 'ai_search_discovery', '/pages/seo-audits': 'seo_audits',
    '/pages/ecommerce-seo': 'ecommerce_seo', '/pages/seo-migration': 'seo_migration'
  };
  function remove(key) {
    try {
      w.sessionStorage.removeItem(key);
      return w.sessionStorage.getItem(key) === null;
    } catch (ignore) { return false; }
  }
  function write(key, record) {
    try {
      var serialised = JSON.stringify(record);
      w.sessionStorage.setItem(key, serialised);
      return w.sessionStorage.getItem(key) === serialised;
    } catch (ignore) { return false; }
  }
  function read(key, maxAge) {
    try {
      var item = JSON.parse(w.sessionStorage.getItem(key));
      var time = new Date().getTime();
      if (!item || item.version !== 1 || !/^SEOH-[a-f0-9]{32}$/.test(item.reference) ||
          categories.indexOf(item.service) === -1 || typeof item.created !== 'number' ||
          item.created > time || time - item.created > maxAge) {
        remove(key); return null;
      }
      return {version: 1, reference: item.reference, service: item.service, created: item.created};
    } catch (ignore) { remove(key); return null; }
  }
  function reference() {
    try {
      if (!w.crypto || typeof w.crypto.getRandomValues !== 'function') { return ''; }
      var bytes = new Uint8Array(16);
      w.crypto.getRandomValues(bytes);
      var value = 'SEOH-';
      for (var i = 0; i < bytes.length; i += 1) { value += ('0' + bytes[i].toString(16)).slice(-2); }
      return value;
    } catch (ignore) { return ''; }
  }
  function revisit() {
    try {
      var entries = w.performance.getEntriesByType('navigation');
      return !!(entries[0] && (entries[0].type === 'reload' || entries[0].type === 'back_forward'));
    } catch (ignore) { return false; }
  }
  function visibility(selector, visible) {
    var nodes = d.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i += 1) { nodes[i].hidden = !visible; }
  }
  function focusFeedback(form) {
    var feedback = form && form.querySelector('.sh-form-errors[role="alert"], .sh-form-success[role="status"]');
    if (feedback) {
      feedback.focus({preventScroll: true});
      feedback.scrollIntoView({behavior: 'auto', block: 'start'});
    }
  }
  function destination() {
    if (!d.querySelector('[data-seohelp-next-steps]')) { return; }
    var complete = read(COMPLETED, COMPLETED_AGE);
    visibility('[data-seohelp-generic-header]', !complete);
    visibility('[data-seohelp-confirmed-header]', !!complete);
    visibility('[data-seohelp-reference-wrap]', !!complete);
    visibility('[data-seohelp-followup-section]', !!complete);
    visibility('[data-seohelp-followup-unavailable]', !complete);
    var references = d.querySelectorAll('[data-seohelp-enquiry-reference]');
    for (var i = 0; i < references.length; i += 1) { references[i].textContent = complete ? complete.reference : ''; }
    var category = complete ? complete.service : 'general';
    var blocks = d.querySelectorAll('[data-seohelp-service]');
    var hasCategory = false;
    for (i = 0; i < blocks.length; i += 1) {
      if (blocks[i].getAttribute('data-seohelp-service') === category) { hasCategory = true; }
    }
    if (!hasCategory) { category = 'general'; }
    for (i = 0; i < blocks.length; i += 1) {
      blocks[i].hidden = blocks[i].getAttribute('data-seohelp-service') !== category;
    }
    var followup = d.getElementById('SEOHelpAdditionalInfo');
    var originalReference = followup && followup.querySelector('#SEOHelpOriginalReference');
    if (originalReference) { originalReference.value = complete ? complete.reference : ''; }
    if (complete) { focusFeedback(followup); }
    if (followup) {
      followup.addEventListener('submit', function (event) {
        var current = read(COMPLETED, COMPLETED_AGE);
        if (!complete || !current || !originalReference || current.reference !== complete.reference) {
          event.preventDefault();
          if (originalReference) { originalReference.value = ''; }
          visibility('[data-seohelp-followup-section]', false);
          visibility('[data-seohelp-followup-unavailable]', true);
          return;
        }
        originalReference.value = current.reference;
      }, true);
    }
  }
  function initialForm() {
    var form = d.getElementById('SEOHelpContact');
    if (!form || form.getAttribute('data-seohelp-enquiry') !== 'initial') { return; }
    var field = form.querySelector('#SEOHelpEnquiryReference');
    var newReference = reference();
    if (field) { field.value = newReference; }
    function refreshUsedReference() {
      var completed = read(COMPLETED, COMPLETED_AGE);
      if (!field || !newReference || !completed || completed.reference !== newReference) { return; }
      newReference = reference();
      field.value = newReference;
    }
    w.addEventListener('pageshow', refreshUsedReference, false);
    d.addEventListener('submit', function (event) {
      if (event.target !== form || event.isTrusted !== true || !field || !newReference ||
          typeof form.checkValidity !== 'function' || !form.checkValidity()) { return; }
      refreshUsedReference();
      if (!newReference) { return; }
      write(PENDING, {version: 1, reference: newReference,
        service: services[w.location.pathname] || 'general', created: new Date().getTime()});
    }, true);
    var success = form.querySelector('[data-seohelp-confirmed].sh-form-success[role="status"]');
    var error = form.querySelector('.sh-form-errors[role="alert"]');
    if (error) { remove(PENDING); return; }
    if (!success) { return; }
    var pending = read(PENDING, PENDING_AGE);
    if (!pending) { return; }
    if (!remove(PENDING) || revisit()) { return; }
    if (!write(COMPLETED, {version: 1, reference: pending.reference,
      service: pending.service, created: new Date().getTime()})) { return; }
    var redirected = false;
    var timeout;
    function continueToNext() {
      if (redirected) { return; }
      redirected = true;
      w.clearTimeout(timeout);
      w.location.replace(NEXT);
    }
    w.addEventListener('pagehide', function () {
      redirected = true;
      w.clearTimeout(timeout);
    }, false);
    d.addEventListener('seo_help_lead_settled', continueToNext, false);
    if (w.__seoHelpLeadSettled === true) { continueToNext(); }
    else { timeout = w.setTimeout(continueToNext, 2500); }
  }
  function init() { initialForm(); destination(); }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init, {once: true}); }
  else { init(); }
}(window, document));
